import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center">
      <p className="font-mono text-xs uppercase tracking-widest text-neutral-500 mb-3">// checkout cancelled</p>
      <h1 className="font-display font-black text-5xl tracking-tighter mb-4">No worries.</h1>
      <p className="text-neutral-400 mb-8">You weren't charged. Come back whenever.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/billing">
          <Button
            className="rounded-full bg-[#CCFF00] text-black hover:bg-[#b8e600] h-12 px-6 font-semibold"
            data-testid="payment-cancel-retry"
          >
            See plans
          </Button>
        </Link>
        <Link to="/app/dashboard">
          <Button
            variant="ghost"
            className="rounded-full h-12 px-6 border border-white/15"
          >
            Back to dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
